<template>
    <div class="tab-content-container">
        <Row type="flex">
            <Col flex="1">
            <Card class="card-container" dis-hover>
                <div slot="title" class="card-title">{{ getTranslation('k082') }}</div>
                <Row class="limit-line table-row-odd" type="flex">
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('k083') }}</Col>
                        <Col flex="2"><Select :transfer="true" v-model="info.OptUIRMeasureFunc" class="input-field"
                            :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                            <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
                        </Select></Col>
                    </Row>
                    </Col>
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('k084') }}</Col>
                        <Col flex="2"><Select :transfer="true" v-model="info.OptUIRWeldTimePrlgFunc" class="input-field"
                            :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                            <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
                        </Select></Col>
                    </Row>
                    </Col>
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('k085') }}</Col>
                        <Col flex="2"><Input type="number" v-model="info.ValUIRStartTime" class="input-field" />&nbsp;ms
                        </Col>
                    </Row>
                    </Col>
                </Row>
                <Row class="limit-line" type="flex">
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('k148') }}</Col>
                        <Col flex="2"><Select :transfer="true" v-model="info.OptUIRRegulationFunc" class="input-field"
                            :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                            <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
                        </Select></Col>
                    </Row>
                    </Col>
                    <Col flex="2">
                    </Col>
                </Row>
            </Card>
            <Card class="card-container" dis-hover>
                <div slot="title" class="card-title">{{ getTranslation('k086') }}</div>
                <Row class="limit-line table-row-odd" type="flex">
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('k087') }}</Col>
                        <Col flex="2"><Input type="number" v-model="info.ValUIRCurrIncMax" class="input-field" />&nbsp;%
                        </Col>
                    </Row>
                    </Col>
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('k091') }}</Col>
                        <Col flex="2"><Input type="number" v-model="info.ValUIRTimeIncMax" class="input-field" />&nbsp;%
                        </Col>
                    </Row>
                    </Col>
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('k093') }}</Col>
                        <Col flex="2"><Select :transfer="true" v-model="info.OptWeldResGlobal" class="input-field"
                            :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                            <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>

                        </Select></Col>
                    </Row>
                    </Col>
                </Row>
                <Row class="limit-line" type="flex">
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('k088') }}</Col>
                        <Col flex="2"><Input type="number" v-model="info.ValUIRCurrDecMax" class="input-field" />&nbsp;%
                        </Col>
                    </Row>
                    </Col>
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('k092') }}</Col>
                        <Col flex="2"><Input type="number" v-model="info.CofSecVoltSamp" class="input-field" /></Col>
                    </Row>
                    </Col>
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('k094') }}</Col>
                        <Col flex="2"><Select :transfer="true" v-model="info.OptWeldResChk" class="input-field"
                            :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                            <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
                        </Select></Col>
                    </Row>
                    </Col>
                </Row>
                <Row class="limit-line table-row-odd" type="flex">
                    <Col flex="1">
                        <Row class="limit-line" type="flex">
                            <Col flex="1" class="left-program desc-field">{{ getTranslation('w097') }}</Col>
                            <Col flex="2">
                         <Select :transfer="true" v-model="info.OptRsv165" class="input-field"
                            :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                            <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
                        </Select>
                    </Col>
                        </Row>
                    </Col>
                    <Col flex="1">
                    </Col>
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('k095') }}</Col>
                        <Col flex="2"><Input type="number" v-model="info.ValResMin" class="input-field" />&nbsp;%</Col>
                    </Row>
                    </Col>
                </Row>
                <Row class="limit-line" type="flex">
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('k089') }}</Col>
                        <Col flex="2"><Input type="number" v-model="info.ValExpulsionTime"
                            class="input-field" />&nbsp;ms</Col>
                    </Row>
                    </Col>
                    <Col flex="1">
                    </Col>
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('k096') }}</Col>
                        <Col flex="2"><Input type="number" v-model="info.ValsValResMax" class="input-field" />&nbsp;%
                        </Col>
                    </Row>
                    </Col>
                </Row>

                <Row class="limit-line" type="flex">
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('k090') }}</Col>
                        <Col flex="2"><Input type="number" v-model="info.ValExpulsionResDec"
                            class="input-field" />&nbsp;%</Col>
                    </Row>
                    </Col>
                    <Col flex="1">
                    </Col>
                    <Col flex="1">                  
                    </Col>
                </Row>

                <Row class="limit-line" type="flex">
                    <Col flex="1">
                    <Row class="limit-line" type="flex">
                        <Col flex="1" class="left-program desc-field">{{ getTranslation('s350') }}</Col>
                        <Col flex="2">
                            <Select :transfer="true" v-model="info.OptWarnBlinkFunc" class="input-field"
                            :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                            <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
                        </Select>
                    </Col>
                    </Row>
                    </Col>
                    <Col flex="1">
                    </Col>
                    <Col flex="1">                  
                    </Col>
                </Row>

            </Card>
            <div class="menu-actions">
                <Button type="primary" size="small" icon="md-download" @click.native="download()">{{ getTranslation('k023')
                    }}</Button>&nbsp;
            </div>
            </Col>
        </Row>
    </div>
</template>
<script>
import { API_URL } from '@/constants/const';
import axios from 'axios';
import { Card, Row, Col, Button, Select, Option, Input } from "view-design"
import { mapGetters } from 'vuex'
import { postJsError } from '@/util/util.js'
export default {
    name: 'CalibrationOne', // 组件名称
    components: {
        Card, Row, Col, Button, Select, Option, Input
    },
    props: {
        kind: {
            type: Number,
            default: 803
        }
    },
    data() {
        return {
            info: {}
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        SwitchList() {
            return [
                this.getTranslation("k048"),
                this.getTranslation("k049"),
            ]
        },
    },
    watch: {

    },

    created() {
        this.init();
    },
    methods: {
        init() {
            let url = API_URL["systemUirInfo"];
            this.mac = this.$route.query.mac
            if (!this.mac) {
                this.$Message.error(this.getTranslation('m041'));
                return
            }
            let params = {
                mac: this.mac
            }
            axios.get(url, {
                params: params
            })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.info = res.data.data;
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
        },
        download() {
            let url = API_URL["systemUirSettingDownload"] + '?mac=' + this.mac
            let params = new FormData();
            this.info && Object.keys(this.info).forEach(key => {
                params.append(key, this.info[key]);
            });
            axios.post(url,
                params
            )
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.$Message.success(res.data.msg);
                    } else if (res && res.data && res.data.msg) {
                        this.$Modal.error({
                            width: 50,
                            title: this.getTranslation("r098"),
                            content: res.data.msg.replace(/\n/g, '<br>'),
                            okText: this.getTranslation("m063"),
                            });
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
        }

    },

}
</script>

<style scoped>
@import url('../../../assets/style/list.css');
@import url('../../../assets/style/tab.css');
</style>